<div
  *ngIf='componentReady'
  [formGroup]='formGroup'
  class='ContactCreateMessageStep'>
  <div class='row'>
    <div class='col col-9 offset-3'>
      <p>Test Email and Test First Name is where we will send the test message for approval</p>
    </div>
  </div>
  <div class='row'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Test email recipients</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <mat-form-field class='w-100'>
        <mat-label>Test email recipients</mat-label>
        <input
          formControlName='recipients'
          matInput
          name='recipients'
          type='text' />
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Test first name</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <mat-form-field class='w-100'>
        <mat-label>Test first name</mat-label>
        <input
          formControlName='first_name'
          matInput
          name='first_name'
          type='text' />
        <mat-error
          *ngIf="(formGroup.get('first_name').touched || formGroup.get('first_name').dirty) && formGroup.get('first_name').errors?.required">
          Please, enter First Name
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Subject</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <mat-form-field class='w-100'>
        <mat-label>Subject</mat-label>
        <input formControlName='subject' matInput name='subject' type='text' />
      </mat-form-field>
    </div>
  </div>
  <div class='row'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Greeting</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <mat-form-field *ngIf='showCustomGreeting'>
        <mat-label>Custom Greeting</mat-label>
        <input formControlName='greeting' matInput type='text' />
      </mat-form-field>
      <button
        (click)='resetGreeting()'
        *ngIf='showCustomGreeting'
        class='btn btn-primary'>
        Back to greetings
      </button>
      <app-select
        (selection)='onGreetingsSelection($event)'
        *ngIf='!showCustomGreeting'
        [defaultValue]="formGroup.get('greeting').value"
        [items]='greetingsSelect.items'
        [label]='greetingsSelect.label'
        formControlName='greeting'></app-select>
    </div>
  </div>
  <div class='row mt-3'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Message</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <app-editor [initOverrides]='editorConfig' formControlName='message'></app-editor>
      <mat-error
        *ngIf="(formGroup.get('message').touched || formGroup.get('message').dirty) && formGroup.get('message').errors?.required">
        Please, enter Message
      </mat-error>
    </div>
  </div>
  <div *ngIf='formGroup.get("include_signature").value === true' class='row mt-3'>
    <div class='col col-6 col-md-9 offset-3'>
      <app-editor [initOverrides]='editorConfig' formControlName='signature'></app-editor>
    </div>
  </div>
  <div class='row mt-3'>
    <div
      class='col col-12 col-md-3 d-flex align-items-center justify-content-end'>
      <mat-label>Signature</mat-label>
    </div>
    <div class='col col-12 col-md-9'>
      <mat-slide-toggle
        formControlName='include_signature'
      ></mat-slide-toggle>
    </div>
  </div>
</div>
